module.exports = __webpack_public_path__ + "static/media/alexandria.logo.black.sm.5ccc00ca.png";